module.exports = __webpack_public_path__ + "img/218.missing_paper.8108a1e3.svg";